import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class FreezeProtectOn extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Freeze Protect On');
    public static getDescription:Function = () => Locale.gettext('Freeze protect turned on');
    public static supportedRoutes:string[] = [ "push", "email" ];
}